import React from 'react'
import {useVisibilityStyles} from '../../../hooks/use-visibility-styles'
import {ClassicLayout} from './classic-layout/classic-layout'
import {HeaderProps} from './interfaces'
import {SideBySideLayout} from './side-by-side-layout/side-by-side'

export const Header: React.FC<HeaderProps> = ({onClickRegistrationButton}) => {
  const {
    allBreakpoints: {isSideBySideHeaderLayout},
  } = useVisibilityStyles()

  return isSideBySideHeaderLayout() ? (
    <SideBySideLayout onClickRegistrationButton={onClickRegistrationButton} />
  ) : (
    <ClassicLayout onClickRegistrationButton={onClickRegistrationButton} />
  )
}
